export default __webpack_public_path__ + "static/11-roadmap-ca1a8bb3c372a3755ebb92b6b04268ab.png";